import { MagnifyingGlass, X } from '@phosphor-icons/react';
import { type ChangeEventHandler, type KeyboardEventHandler, useState } from 'react';
import ButtonIcon from '../buttons/ButtonIcon';
import './css/search.css';
import classNames from 'classnames';
import translations from '../../translations';

interface Props {
    className?: string;
    id?: string;
    value?: string | undefined;
    onChange: (value: string) => void;
    placeholder?: string;
}

const SearchInput = ({
    className,
    id = 'search-input',
    value = '',
    onChange: submit,
    placeholder = translations.COMMON_search,
}: Props) => {
    const [searchValue, setSearchValue] = useState(value);

    const onKeyup: KeyboardEventHandler<HTMLInputElement> = (event) => {
        if (event.key === 'Enter') {
            submit(searchValue);
        }
    };

    const onChange: ChangeEventHandler<HTMLInputElement> = (event) => {
        setSearchValue(event.target.value);
    };

    const onClickClear = () => {
        setSearchValue('');
        submit('');
    };

    const onClickSearch = () => submit(searchValue);

    const wrapperClasses = classNames('search-control-wrapper', className);

    return (
        <div className={wrapperClasses}>
            <input
                id={id}
                className="search-input"
                value={searchValue}
                onChange={onChange}
                placeholder={placeholder}
                onKeyUp={onKeyup}
                aria-label={translations.COMMON_search}
            />
            {searchValue.length > 0 && (
                <ButtonIcon
                    className="clear-btn"
                    onClick={onClickClear}
                    aria-label={translations.SEARCH_clear_button_label}
                >
                    <X className="clear-icon" />
                </ButtonIcon>
            )}
            <button
                title={translations.COMMON_search}
                aria-label={translations.SEARCH_search_button_label}
                className="search-input-button"
                type="button"
                onClick={onClickSearch}
            >
                <MagnifyingGlass height={18} width={18} />
            </button>
        </div>
    );
};

export default SearchInput;
